const FALLBACK_API_BASE_URL = '/api';

export const resolveApiBaseUrl = (value: string | undefined): string => {
  const normalized = value?.trim();
  if (!normalized) {
    return FALLBACK_API_BASE_URL;
  }

  return normalized.endsWith('/') && normalized.length > 1
    ? normalized.slice(0, -1)
    : normalized;
};

export const resolveBackendConfig = (env: {
  VITE_APP_API_BASE_URL?: string;
}) => ({
  apiBaseUrl: resolveApiBaseUrl(env.VITE_APP_API_BASE_URL),
});
